module.exports = __webpack_public_path__ + "static/avenir-bold-09fab6bcc2c72809ac748811363b32e6.woff2";